import React from 'react'
import Vars from 'Consts/vars'
import { truncate_text } from 'Helpers/utils'
// import Image from 'next/image'
import ImageFallback from 'Components/imagefallback'

const TypeOne = (props) => (
  <div
    className={`fdn-article-card-mobile-${props.type} ${
      props.is_sponsored && props.size === 'main' ? `sponsored-main` : ``
    }`}
  >
    <a className="article-image" href={props.article.url}>
      <div
        style={{
          width: '100%',
          height: '100%',
          position: 'relative',
        }}
      >
        <ImageFallback
          src={props.article.image}
          alt={props.article.title}
          layout="fixed"
          objectFit="cover"
          width={100}
          height={100}
          quality={80}
          fallbackSrc={Vars.imageBrokenDefault.square}
        />
      </div>

      {props.is_sponsored && (
        <p className="article-text-sponsored">Sponsored</p>
      )}
    </a>
    <div className="article-info">
      <p className="article-category">
        {truncate_text(props.article.category.name, 26)}
      </p>
      <a className="article-title" href={props.article.url}>
        {props.article.title}
      </a>
    </div>
    <style jsx>
      {`
        .fdn-article-card-mobile-${props.type} {
          display: flex;
          flex-flow: row;
          border: none;
        }
        .fdn-article-card-mobile-${props.type}.sponsored-main {
          display: flex;
          flex-direction: column;
          flex-flow: column;
          border: none;
        }
        .fdn-article-card-mobile-${props.type} .article-info {
          word-break: break-word;
        }
        .fdn-article-card-mobile-${props.type}.sponsored-main .article-info {
          margin: -30px 10px 0px 10px;
          background: rgba(0, 0, 0, 0.75);
          word-break: break-word;
          padding: 10px;
          z-index: 2;
        }
        .fdn-article-card-mobile-${props.type} .article-image {
          width: 100px;
          height: 100px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          flex-shrink: 0;
          overflow: hidden;
          margin: 0 8px 0 0;
        }
        .fdn-article-card-mobile-${props.type}.sponsored-main .article-image {
          width: 100%;
          height: 288px;
          margin: 0;
        }
        .fdn-article-card-mobile-${props.type} .article-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .fdn-article-card-mobile-${props.type}
          .article-info
          p.article-category {
          font-family: Roboto;
          font-size: 12px;
          font-weight: 400;
          color: #db284e;
          margin: 0 0 4px 0;
          text-transform: uppercase;
          padding: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .fdn-article-card-mobile-${props.type}.sponsored-main
          .article-info
          p.article-category {
          font-family: Roboto;
          font-size: 12px;
          font-weight: 400;
          color: #fff;
          margin: 0 0 4px 0;
          text-transform: uppercase;
          padding: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .fdn-article-card-mobile-${props.type} .article-info a.article-title {
          font-family: ${props.font_title};
          font-size: 12px;
          line-height: 1.5;
          color: #000;
          margin: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
        .fdn-article-card-mobile-${props.type}.sponsored-main
          .article-info
          a.article-title {
          font-family: ${props.font_title};
          font-size: 14px;
          font-weight: 600;
          line-height: 1.5;
          color: #fff;
          margin: 10px 0 0 0;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
        }
        .fdn-article-card-mobile-${props.type}
          .article-image
          .article-text-sponsored {
          position: absolute;
          top: 5px;
          left: 5px;
          margin: 0;
          padding: 4px 8px;
          background-color: #ffffff;
          border-radius: 18px;
          color: #db284e;
          font-family: Roboto;
          font-size: 8px;
          font-style: normal;
          font-weight: 500;
          line-height: 10px;
          letter-spacing: 0px;
          text-align: left;
          text-transform: uppercase;
        }
        .fdn-article-card-mobile-${props.type}.sponsored-main
          .article-image
          .article-text-sponsored {
          top: 8px;
          left: 8px;
        }
      `}
    </style>
  </div>
)

export default TypeOne
